import { Link } from "@tanstack/react-router";
import { NAV, navLeafLinkProps, type NavItem } from "./nav-config";
import { LanguageSwitcher } from "./LanguageSwitcher";


/** Mobile/tablet (<xl) collapsible menu rendered below the header bar. */
export function MobileNav({ onClose, items = NAV, isBn = false }: { onClose: () => void; items?: NavItem[]; isBn?: boolean }) {
  return (
    <nav id="mobile-nav" aria-label="Main" className="xl:hidden mt-2 rounded-3xl border border-border bg-popover p-4 flex flex-col max-h-[80vh] overflow-y-auto shadow-[var(--shadow-elegant)] animate-in fade-in-0 slide-in-from-top-2 duration-150 ease-out origin-top">
      {items.map((n) =>
        n.kind === "link" ? (
          <Link
            key={n.label}
            to={n.to}
            onClick={onClose}
            className="px-4 py-3 text-base text-foreground hover:bg-card rounded-lg transition"
          >
            {n.label}
          </Link>
        ) : (
          <div
            key={n.label}
            className="py-1 border-t border-border/50 first:border-t-0 mt-1 first:mt-0"
          >
            <div className="px-4 pt-3 pb-1 text-xs font-semibold uppercase tracking-[0.2em] text-primary">
              {n.label}
            </div>
            {n.items.map((it) => (
              <Link
                key={`${it.to}-${it.hash ?? it.label}`}
                {...navLeafLinkProps(it)}
                onClick={onClose}
                className="block px-4 py-2 text-sm text-foreground/80 hover:text-foreground hover:bg-card rounded-lg transition"
              >
                {it.label}
              </Link>
            ))}
          </div>
        ),
      )}
      <div className="mt-3 mx-4 flex justify-start">
        <LanguageSwitcher onNavigate={onClose} />
      </div>
      <a
        href="https://tool.freelancertamal.com/"
        target="_blank"
        rel="noopener"
        onClick={onClose}
        className="mt-2 mx-4 inline-flex justify-center rounded-full border border-primary/60 text-primary px-5 py-3 text-sm font-medium"
      >
        Free Audit
      </a>
      <Link
        to={isBn ? "/bn/book" : "/book"}
        onClick={onClose}
        className="mt-2 mx-4 mb-2 inline-flex justify-center rounded-full bg-primary text-primary-foreground px-5 py-3 text-sm font-medium"
      >
        {isBn ? "কল বুক করুন" : "Book a call"}
      </Link>
    </nav>
  );
}